import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useAlertPopup } from "@/global-data/use-alert-popup";
import { cn } from "@/lib/utils";
import { Check, X } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "../ui/button";
import { IconRender } from "./Icon-render";

export const AlertPopup = () => {
  const { open, closeAlert, type, title, message } = useAlertPopup();
  return (
    <AlertDialog open={open} onOpenChange={() => closeAlert()}>
      <AlertDialogContent className="p-0">
        <ScrollArea className="max-h-[600px] w-full overflow-y-auto alert-popup p-10">
          <div>
            <AlertDialogHeader className="flex items-center gap-4 justify-center">
              {type === "error" && (
                <span className="inline-flex aspect-square items-center justify-center border-2 border-dashed text-red-500  border-red-500 rounded-full p-1 w-[100px]">
                  <X size={40} />
                </span>
              )}
              {type === "success" && (
                <span className="inline-flex aspect-square items-center justify-center border-2 border-l-dashed  text-green-500  border-green-500 rounded-full p-1 w-[100px]">
                  <Check size={40} />
                </span>
              )}
              <AlertDialogTitle
                className={cn(
                  "",
                  { "text-red-500": type === "error" },
                  { "text-green-500": type === "success" }
                )}
              >
                {title || ""}
              </AlertDialogTitle>
              <Button
                onClick={() => closeAlert()}
                size={"icon"}
                className="rounded-full absolute top-0 right-2"
                variant={"outline"}
              >
                <IconRender name="X" />
              </Button>
            </AlertDialogHeader>
            <AlertDialogDescription className="text-center">
              {message || ``}
            </AlertDialogDescription>
          </div>
        </ScrollArea>
        <AlertDialogFooter className="justify-center gap-4 items-center w-full hidden">
          <div className="flex justify-center  w-full mb-30">
            <AlertDialogCancel
              className={cn(
                { "bg-red-500 text-white": type === "error" },
                { "bg-green-500 text-white": type === "success" }
              )}
              onClick={() => closeAlert()}
            >
              Continue
            </AlertDialogCancel>
          </div>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
